import { Coordinates, TransformOrigin } from 'types'

export function transformOriginMultiplier(origin: TransformOrigin): Coordinates {
    switch (origin) {
        case 'bottom-left':
            return { x: 0, y: 1 }
        case 'bottom-right':
            return { x: 1, y: 1 }
        case 'center':
            return { x: 0.5, y: 0.5 }
        case 'top-left':
            return { x: 0, y: 0 }
        case 'top-right':
            return { x: 1, y: 0 }
    }
}
